import { render, staticRenderFns } from "./msg_details.vue?vue&type=template&id=5aca455c&scoped=true&"
import script from "./msg_details.vue?vue&type=script&lang=js&"
export * from "./msg_details.vue?vue&type=script&lang=js&"
import style0 from "./msg_details.vue?vue&type=style&index=0&id=5aca455c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca455c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aca455c')) {
      api.createRecord('5aca455c', component.options)
    } else {
      api.reload('5aca455c', component.options)
    }
    module.hot.accept("./msg_details.vue?vue&type=template&id=5aca455c&scoped=true&", function () {
      api.rerender('5aca455c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/msg_details.vue"
export default component.exports